<app-enfaf-modal
  [title]="title"
  svgIcon="pocket-modal"
  (onClose)="confirmCloseModal()"
  (onConfirm)="assignCourses()"
  [isLoading]="isAssigning"
  buttonConfirmText="Asignar"
  [disableConfirmButton]="studentForm.invalid || isAssigning"
>
  <form class="content" [formGroup]="studentForm" autocomplete="off">
    <div class="form-control-courses">
      <div class="courses-content">
        <enfaf-multi-autocomplete-light
          [fetchData]="fetchCourses.bind(this)"
          [selectedOptions]="selectedCourses"
          [disableOptions]="disabledCourses"
          [placeholder]="'Buscar'"
          (selectedChanged)="onSelectedCoursesChanged($event)"
        >
        </enfaf-multi-autocomplete-light>
        @if (selectedCourses.length > 0) {
          <div class="selected-courses-list">
            @for (course of selectedCourses; track $index) {
              <div class="course-item">
                <span class="course-name" [attr.title]="course.title">{{ course.title }}</span>
                <app-enfaf-icon
                  [svgIconName]="'trash-red'"
                  [iconSize]="'16px'"
                  [iconStyle]="{ color: '#E03131' }"
                  [isButton]="true"
                  (onClick)="removeCourse(course.id)"
                  class="remove-icon"
                >
                </app-enfaf-icon>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </form>
</app-enfaf-modal>
